import React, { memo, useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Input,
  Row,
  Col,
  Button,
  Checkbox,
  Select,
  Spin,
  Switch,
  Radio,
  DatePicker,
  Tooltip,
} from 'antd';
import action from '@flux/action';
import useTheme from '@hooks/useTheme';
import _ from 'lodash';
import ClientCompany from './clientCompany';
import TargetCompany from './targetCompany';
import { useHistory } from 'react-router-dom';
import ProjectToast from '../projectToast';
import { getSystemModuleTemplate } from '@service/apis';
import { processSystemModuleResponse } from '@modules/systemSetting/systemModule/helper';
import { SecondaryUseTips } from '@model/projects';
import { API } from '@service';
import { setSessionStorage } from '@utils/windowUtil';

const { Option } = Select;

const plainOptions = [
  {
    label: (
      <span>
        <span>Please reach out and provide our team a demo of the tool</span>
      </span>
    ),
    value: '1',
  },
  // {
  //   label: (
  //     <span>
  //       I would like to have someone from the M&A Gateway team reach out and
  //       &nbsp;
  //       <span style={{ fontWeight: 500 }}>help support this proposal</span>
  //     </span>
  //   ),
  //   value: '2',
  // },
  // {
  //   label: (
  //     <span>
  //       I want to use this project to pitch our digital capabilities or
  //       cross-sell products using M&A Gateway - please reach out and
  //       <span style={{ fontWeight: 500 }}>
  //         &nbsp;walk me through how I can tee this up to the client
  //       </span>
  //     </span>
  //   ),
  //   value: '3',
  // },
  {
    label: (
      <span>
        No support required - &nbsp;
        <span style={{ fontWeight: 500 }}>
          my team is familiar with M&A Gateway
        </span>
      </span>
    ),
    value: '4',
  },
  // {
  //   label: (
  //     <span>
  //       Just learning how the tool works -{' '}
  //       <span style={{ fontWeight: 500 }}>I’ll figure it out</span> and reach
  //       out if I have any questions
  //     </span>
  //   ),
  //   value: '5',
  // },
  {
    label: (
      <span>
        I would like to understand
        <span style={{ fontWeight: 500 }}>
          &nbsp;how to get product-related revenue credit
        </span>
      </span>
    ),
    value: '6',
  },
];

const getFormProjectName = (isInternalUseOnly, projectName) => {
  if (isInternalUseOnly && projectName?.startsWith('Project-Test')) {
    return projectName?.slice(12);
  }
  if (!isInternalUseOnly && projectName?.startsWith('Project')) {
    return projectName?.slice(7);
  }
  return projectName || '';
};

function ProjectsDetailForm(props) {
  const {
    queryCompanyResult,
    queryCompanyName,
    loading,
    steps,
    tranStep,
    saveCreateProjectData,
    changeSettingCompanyInstance,
    saveData,
    clearCompanyName,
    changeLoading,
  } = props;
  const { theme } = useTheme();
  const isLightMode = theme === 'light';
  const liStyles = {
    position: 'absolute',
    left: 2,
    color: isLightMode ? '#2c2c2c' : '#DBDBDB',
    fontFamily: 'Helvetica Neue ,Arial',
    fontSize: '1rem',
    lineHeight: '0.875rem',
    height: '0.875rem',
  };
  const history = useHistory();
  const [form] = Form.useForm();
  const [isShow, setIsShow] = useState(false);
  const [whichSide, setWhichSide] = useState('');
  const [projectTypes, setProjectTypes] = useState([]);
  const handleChange = _.debounce((val, name, isLoading, mode) => {
    queryCompanyName(val, name, isLoading, mode);
  }, 1000);
  const formData = {
    buyerName:
      saveData.buyerName && saveData.buyerCraftId
        ? `${saveData.buyerName} (DUNS : ${saveData.buyerDuns})`
        : '',
    targetName:
      saveData.targetName && saveData.targetCraftId
        ? `${saveData.targetName} (DUNS : ${saveData.targetDuns})`
        : '',
    // projectName: saveData.projectName,
    projectName: getFormProjectName(
      saveData?.isInternalUseOnly,
      saveData?.projectName,
    ),
    theme: saveData.theme === 'light',

    targetDealCloseDate: saveData.targetDealCloseDate,
    anticipatedAnnouncementDate: saveData.anticipatedAnnouncementDate,
    isSingleCompany: saveData.isSingleCompany,
    singleCompanyInstance: saveData.singleCompanyInstance,
    companyInstance: saveData.companyInstance,
    targetLabel: saveData.targetLabel,
    buyerLabel: saveData.buyerLabel,
    stageLabel: saveData?.engagementOpportunity,
    salesforceOpportunityID: saveData?.salesforceOpportunityID,
    supplementalRequests: saveData?.supplementalRequests,
  };
  const initiateProjectTypes = async () => {
    const types = (await API.getAllProjectInstances()) || [];
    setProjectTypes(types.filter((t) => !t.isDeleted));
  };

  useEffect(() => {
    form.setFieldsValue(formData);
    initiateProjectTypes();
  }, []);

  useEffect(() => {
    // 当SaleForceOpportunity 是N/A时，清空 "Salesforce Opportunity ID" input的值
    if (saveData.isSalesforceOpportunityIDApplicable === false) {
      form.setFieldsValue({
        ...formData,
        salesforceOpportunityID: '',
      });
    }
  }, [saveData.isSalesforceOpportunityIDApplicable]);

  // useEffect(() => {
  //   console.log('saveData:', typeof saveData, JSON.stringify(saveData, null, 2));
  // }, [saveData]);
  // console.log({ saveData });
  const onFinish = async (vals) => {
    changeLoading(true);
    const data = {
      ...saveData,
      targetLabel: saveData.targetLabel
        ? saveData.targetLabel
        : saveData.instanceType !== 'Divestiture'
        ? 'Target'
        : 'Buyer',
      buyerLabel: saveData.buyerLabel
        ? saveData.buyerLabel
        : saveData.instanceType !== 'Divestiture'
        ? 'Buyer'
        : 'RemainCo',
      lastNum: 1,
      isEditing: !saveData.stepOneFinish,
      theme: saveData.theme === 'light' ? 'light' : 'dark',
    };

    if (!saveData.winTheEngagement) {
      saveData.winTheEngagement = false;
    }

    if (!saveData.customizeModule) {
      try {
        const response = await getSystemModuleTemplate(data.companyInstance);
        data.customizeModule = processSystemModuleResponse(
          response,
          true,
          true,
          saveData.instanceType,
        )?.customizeModule;
        data.customizeModule = data.customizeModule.filter(
          (i) =>
            Boolean(i?.internalPermissions?.length) ||
            (i?.display && i?.type === 'multiSection'),
        );
      } catch (e) {
        console.log(e);
      }
    }

    if (
      (saveData.buyerCheck && saveData.targetCheck) ||
      (saveData.buyerCheck && !saveData.targetCheck)
    ) {
      // skip to buyer manual company page.
      saveCreateProjectData({ ...data, currentNum: 2, currentStep: 1 });
    } else if (!saveData.buyerCheck && saveData.targetCheck) {
      // skip to target manual company page.
      saveCreateProjectData({ ...data, currentNum: 3, currentStep: 1 });
    } else {
      // skip to Team Detail page.

      saveCreateProjectData({
        ...data,
        isEditing: true,
        // currentNum: 0,
        currentStep: tranStep(steps),
      });
      history.push(`/projects/create/${steps}`);
    }
    setSessionStorage('newProjectName', vals.projectName);
    changeLoading(false);
  };

  useEffect(() => {
    changeSettingCompanyInstance('Integration');
  }, []);

  // const handleSingleCompany = (e) => {
  //   if (e.target.checked) {
  //     clearCompanyName('targetName');
  //     form.setFieldsValue({
  //       targetName: '',
  //       singleCompanyInstance: 'Integration',
  //     });
  //   } else {
  //     form.setFieldsValue({
  //       singleCompanyInstance: 'Divestiture',
  //     });
  //   }

  //   saveCreateProjectData({
  //     ...saveData,
  //     targetName: null,
  //     targetCraftId: null,
  //     isSingleCompany: e.target.checked,
  //     singleCompanyInstance: e.target.checked
  //       ? saveData.singleCompanyInstance
  //       : 'Integration',
  //     targetCheck: false,
  //   });
  // };
  return (
    <div className="projectDetail">
      {saveData.currentNum === 1 && (
        <Form
          onFinish={onFinish}
          onFinishFailed={() => {
            // the function scrolling to exact warning position need to be done.
            form.scrollToField('projectName');
            saveCreateProjectData({
              ...saveData,
              targetNotFound: false,
              buyerNotFound: false,
            });
          }}
          name="createProject"
          form={form}
          // initialValues={saveData}
          layout="vertical"
          autoComplete="off"
        >
          <Row>
            <Col className="projectDetailLeft" span={11}>
              <Form.Item
                className="width-project-word-label"
                required
                label={
                  <div className="project-word-box">
                    Project Name
                    <Tooltip
                      title={`"Project" will be added before your Project Name automatically upon creation.`}
                    >
                      <span>
                        <span className="appkiticon icon-information-fill" />
                      </span>
                    </Tooltip>
                  </div>
                }
              >
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{ whiteSpace: 'nowrap', marginRight: '0.625rem' }}
                  >
                    {saveData.isInternalUseOnly ? 'Project-Test' : 'Project'}
                  </div>
                  <Form.Item
                    noStyle
                    name="projectName"
                    rules={[
                      // {
                      //   required: true,
                      //   whitespace: true,
                      //   message: 'Project Name is required!',
                      // },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || !value.trim()) {
                            window.scrollTo(0, 0);
                            return Promise.reject('Project Name is required!');
                          }
                          if (
                            value?.toLocaleLowerCase()?.startsWith('project ')
                          ) {
                            window.scrollTo(0, 0);
                            return Promise.reject(
                              'Please remove "Project" from the name above as it will be added automatically upon creation.',
                            );
                          }
                          return Promise.resolve();
                        },
                      }),
                    ]}
                  >
                    <Input
                      // value={form.getFieldValue('projectName')}
                      maxLength={100}
                      onChange={async (e) => {
                        saveCreateProjectData({
                          ...saveData,
                          projectName:
                            (saveData.isInternalUseOnly
                              ? 'Project-Test '
                              : 'Project ') + e.target.value,
                        });
                        // await form.setFieldsValue({ projectName: e.target.value });
                      }}
                    />
                  </Form.Item>
                </div>
              </Form.Item>
              <Checkbox
                style={{ marginBottom: '1.25rem' }}
                checked={saveData.isInternalUseOnly}
                onChange={async (e) => {
                  await saveCreateProjectData({
                    ...saveData,
                    projectName:
                      (e.target.checked ? 'Project-Test ' : 'Project ') +
                      form.getFieldValue('projectName'),
                    isInternalUseOnly: e.target.checked,
                  });
                }}
              >
                <span className="checker-word">
                  Test project for PwC internal use only
                </span>
              </Checkbox>

              <Form.Item
                label="Confidential"
                name="confidential"
                initialValue={saveData.confidential}
                rules={[
                  { required: true, message: 'Option is required!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value === 'none') {
                        return Promise.reject('Option is required!');
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                {/* Yes
                <Switch
                  checked={saveData.confidential}
                  onChange={(bool) => {
                    saveCreateProjectData({
                      ...saveData,
                      confidential: bool,
                    });
                  }}
                />
                No */}
                <Select
                  style={{
                    width: 300,
                    backgroundColor: '#2C2C2C',
                  }}
                  dropdownClassName="project-setting-select"
                  onChange={(v) => {
                    saveCreateProjectData({
                      ...saveData,
                      confidential: v,
                    });
                  }}
                >
                  <Option value="none" disabled style={{ display: 'none' }}>
                    Please select an option
                  </Option>
                  <Option value={true}>Yes</Option>
                  <Option value={false}>No</Option>
                </Select>
              </Form.Item>

              <Form.Item
                className="infoConfirmed"
                label={
                  <div>
                    <span>{SecondaryUseTips}</span>
                    <span className="required-star">*</span>
                  </div>
                }
                name="infoConfirmed"
                initialValue={saveData.secondaryUse}
                rules={[
                  { required: true, message: 'Option is required!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value === 'none') {
                        return Promise.reject('Option is required!');
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                {/* Yes
                <Switch
                  checked={saveData.secondaryUse}
                  onChange={(bool) => {
                    saveCreateProjectData({
                      ...saveData,
                      secondaryUse: bool,
                    });
                  }}
                />
                No */}
                <Select
                  style={{
                    width: 300,
                    backgroundColor: '#2C2C2C',
                  }}
                  dropdownClassName="project-setting-select"
                  onChange={(v) => {
                    saveCreateProjectData({
                      ...saveData,
                      secondaryUse: v,
                    });
                  }}
                >
                  <Option value="none" disabled style={{ display: 'none' }}>
                    Please select an option
                  </Option>
                  <Option value="Yes">Yes</Option>
                  <Option value="No">No</Option>
                  <Option value="unsure">I am not sure</Option>
                </Select>
              </Form.Item>
              {/* <Form.Item name="isSingleCompany">
                <Checkbox
                  // options={plainOptions}
                  checked={saveData.isSingleCompany}
                  onChange={(e) => {
                    handleSingleCompany(e);
                  }}
                >
                  Single Company
                </Checkbox>
              </Form.Item> */}

              {/* {saveData.isSingleCompany && ( 
                <div className="create-project-radio-group">
                  <Form.Item name="singleCompanyInstance">
                    <Radio.Group
                      onChange={(ele) => {
                        saveCreateProjectData({
                          ...saveData,
                          singleCompanyInstance: ele.target.value,
                        });
                      }}
                    >
                      <Radio value="Integration">Integration</Radio>
                      <Radio value="Divestiture">Divestiture / Separation</Radio>
                    </Radio.Group>
                  </Form.Item>
                </div>
              )} */}

              <Form.Item
                label="Project Type"
                name="companyInstance"
                className="company-instance-switch-wrapper"
                initialValue={saveData.companyInstance}
                rules={[
                  { required: true, message: 'Option is required!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value === 'none') {
                        return Promise.reject('Option is required!');
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                {/* Buy-Side
                <Switch
                  checked={saveData.companyInstance}
                  onChange={(bool) => {
                    saveData.customizeModule && delete saveData.customizeModule;
                    saveCreateProjectData({
                      ...saveData,
                      companyInstance: bool,
                    });
                    changeSettingCompanyInstance(
                      bool ? 'Integration' : 'Divestiture',
                    );
                  }}
                />
                Sell-Side */}
                <Select
                  style={{
                    width: 300,
                    backgroundColor: '#2C2C2C',
                  }}
                  dropdownClassName="project-setting-select project-instance-dropdown"
                  onChange={(v) => {
                    saveData.customizeModule && delete saveData.customizeModule;
                    const instanceType =
                      projectTypes.find((e) => e.id === v)?.type ||
                      'Integration';
                    saveCreateProjectData({
                      ...saveData,
                      companyInstance: v,
                      instanceType,
                    });
                    changeSettingCompanyInstance(instanceType);
                  }}
                >
                  <Option value="none" disabled style={{ display: 'none' }}>
                    Please select an option
                  </Option>
                  {/* <Option value={true}>Buy-Side</Option>
                  <Option value={false}>Sell-Side</Option> */}
                  {projectTypes.map((e, i) => (
                    <Option value={e.id} key={`${i}-${e.id}`}>
                      {e.instanceName}
                    </Option>
                  ))}
                </Select>
              </Form.Item>

              <div style={{ display: 'flex', flexFlow: 'column' }}>
                <div
                  className="project-form-wrapper"
                  // style={{
                  //   order: saveData.companyInstance ? 1 : 3,
                  // }}
                >
                  <Form.Item name="buyerCheckerName" className="checker">
                    <Checkbox
                      checked={saveData.buyerCheck}
                      onChange={async (e) => {
                        clearCompanyName('buyerName');
                        await saveCreateProjectData({
                          ...saveData,
                          buyerCheck: e.target.checked,
                        });
                        await form.setFieldsValue({ buyerName: '' });
                        if (
                          e.target.checked &&
                          form.getFieldValue('targetName')
                        ) {
                          form.validateFields(['targetName']);
                        }
                      }}
                    >
                      <span className="checker-word">Not Available</span>
                    </Checkbox>
                  </Form.Item>

                  {(() => {
                    // displaying factiva company information or no result after searching.
                    let text = '';
                    let name = '';
                    let nodes = null;
                    if (saveData?.buyerCompanyInfo?.isFromDuns) {
                      text = `${saveData.buyerCompanyInfo.name} (${saveData.buyerCompanyInfo.duns})`;
                      name = 'from-duns-not-available';
                      nodes = (
                        <Tooltip
                          placement="bottomLeft"
                          title={
                            <span style={{ color: '#DBDBDB' }}>
                              Limited data available for this company. Data will
                              be updated within next 24 hours.
                            </span>
                          }
                        >
                          <span
                            className="appkiticon icon-alert-fill"
                            style={{ marginRight: 6 }}
                          />
                        </Tooltip>
                      );
                    }
                    if (saveData.buyerCheck) {
                      text = 'Not Available';
                      name = 'not-available';
                    }
                    return (
                      <div
                        className={name}
                        onClickCapture={() => {
                          name === 'from-duns-not-available' &&
                            saveCreateProjectData({
                              ...saveData,
                              buyerCompanyInfo: {
                                isFromDuns: false,
                              },
                            });
                        }}
                      >
                        {nodes}
                        {text}
                      </div>
                    );
                  })()}
                  <Form.Item
                    className="with-radio-label"
                    label={
                      <div>
                        <div>
                          Company A Name
                          <span
                            className={
                              saveData.buyerCheck
                                ? 'not-allowed'
                                : 'find-DUNS-num'
                            }
                            onClick={() => {
                              if (!saveData.buyerCheck) {
                                setWhichSide('buyer');
                                setIsShow(!isShow);
                              }
                            }}
                          >
                            (Find a DUNS number)
                          </span>
                        </div>
                        <div className="create-project-radio-group">
                          <Radio.Group
                            name="buyerRadioGroup"
                            disabled={saveData.buyerCheck}
                            value={saveData.buyerMode || 'name'}
                            onChange={(ele) => {
                              saveCreateProjectData({
                                ...saveData,
                                buyerMode: ele.target.value,
                              });
                            }}
                          >
                            <Radio value="name">Company Name</Radio>
                            <Radio value="duns">DUNS Number</Radio>
                            <Radio value="website">Company Website</Radio>
                          </Radio.Group>
                        </div>
                      </div>
                    }
                    name="buyerName"
                    rules={[
                      {
                        required:
                          !saveData?.buyerCompanyInfo?.isFromDuns &&
                          !saveData.buyerCheck,
                        whitespace: true,
                        message: `Client Name is required!`,
                      },
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          if (!value || getFieldValue('targetName') !== value) {
                            return Promise.resolve();
                          }
                          if (saveData.buyerMode === 'website') {
                            return Promise.reject(
                              'Buyer Name can not be the same as Target Name!',
                            );
                          }
                        },
                      }),
                    ]}
                  >
                    <Select
                      className="select company-select"
                      dropdownClassName="down-box"
                      showSearch
                      disabled={saveData.buyerCheck || isShow}
                      filterOption={false}
                      notFoundContent={
                        loading ? (
                          <Spin size="small" style={{ marginLeft: '48%' }} />
                        ) : null
                      }
                      onSearch={(e) => {
                        const val =
                          saveData.buyerMode === 'website'
                            ? encodeURIComponent(e)
                            : e;
                        val &&
                          handleChange(
                            val,
                            'buyerName',
                            true,
                            saveData.buyerMode,
                          );
                      }}
                      onFocus={() => {
                        form.setFieldsValue({ buyerName: '' });
                        if (form.getFieldValue('targetName')) {
                          form.validateFields(['targetName']);
                        }
                        saveCreateProjectData({
                          ...saveData,
                          buyerCompanyInfo: {
                            isFromDuns: false,
                          },
                        });
                      }}
                      onChange={(e, attrs) => {
                        saveCreateProjectData({
                          ...saveData,
                          buyerName: attrs['company-name'],
                          buyerCraftId: attrs['craft-id'],
                          buyerDuns: attrs['buyer-duns'],
                        });
                        if (form.getFieldValue('targetName')) {
                          form.validateFields(['targetName']);
                        }
                      }}
                      onBlur={() => {
                        saveCreateProjectData({
                          ...saveData,
                          buyerNotFound: false,
                        });
                      }}
                    >
                      {!loading &&
                        Array.isArray(queryCompanyResult.buyerName) &&
                        queryCompanyResult.buyerName.map(
                          (item) =>
                            item.displayName && (
                              <Option
                                value={`${item.displayName} (DUNS : ${item.duns})`}
                                craft-id={item.craftId}
                                buyer-duns={item.duns}
                                company-name={item.displayName}
                                key={item.duns}
                              >
                                <ul style={{ position: 'relative' }}>
                                  <li style={liStyles}>
                                    {`${item.displayName} (DUNS : ${item.duns})`}
                                  </li>
                                </ul>
                              </Option>
                            ),
                        )}
                    </Select>
                  </Form.Item>
                  {saveData.buyerNotFound &&
                    !loading &&
                    Array.isArray(queryCompanyResult.buyerName) &&
                    !queryCompanyResult.buyerName?.length && (
                      <div className="not-found-company-error">
                        Company not found, try locating the DUNS number in PwC
                        Salesforce account details
                      </div>
                    )}
                </div>

                <Form.Item
                  label="Rename Company A Label"
                  name="buyerLabel"
                  // style={{
                  //   order: saveData.companyInstance ? 2 : 4,
                  // }}
                >
                  <Input
                    maxLength={15}
                    placeholder={
                      saveData.instanceType !== 'Divestiture'
                        ? 'Buyer'
                        : 'RemainCo'
                    }
                    onChange={(ele) => {
                      saveCreateProjectData({
                        ...saveData,
                        buyerLabel: ele.target.value,
                      });
                    }}
                  />
                </Form.Item>

                {!saveData.isSingleCompany && (
                  <div
                    className="project-form-wrapper"
                    // style={{
                    //   order: saveData.companyInstance ? 3 : 1,
                    // }}
                  >
                    <Form.Item name="targetCheckerName" className="checker">
                      <Checkbox
                        checked={saveData.targetCheck}
                        onChange={async (e) => {
                          clearCompanyName('targetName');
                          await saveCreateProjectData({
                            ...saveData,
                            targetCheck: e.target.checked,
                          });

                          await form.setFieldsValue({ targetName: '' });
                          if (
                            e.target.checked &&
                            form.getFieldValue('buyerName')
                          ) {
                            form.validateFields(['buyerName']);
                          }
                        }}
                      >
                        <span className="checker-word">Not Available</span>
                      </Checkbox>
                    </Form.Item>

                    {(() => {
                      let text = '';
                      let name = '';
                      let nodes = null;
                      if (saveData?.targetCompanyInfo?.isFromDuns) {
                        text = `${saveData.targetCompanyInfo.name} (${saveData.targetCompanyInfo.duns})`;
                        name = 'from-duns-not-available';
                        nodes = (
                          <Tooltip
                            placement="bottomLeft"
                            title={
                              <span style={{ color: '#DBDBDB' }}>
                                Limited data available for this company. Data
                                will be updated within next 24 hours.
                              </span>
                            }
                          >
                            <span
                              className="appkiticon icon-alert-fill"
                              style={{ marginRight: 6 }}
                            />
                          </Tooltip>
                        );
                      }
                      if (saveData.targetCheck) {
                        text = 'Not Available';
                        name = 'not-available';
                      }
                      return (
                        <div
                          className={name}
                          onClickCapture={() => {
                            name === 'from-duns-not-available' &&
                              saveCreateProjectData({
                                ...saveData,
                                targetCompanyInfo: {
                                  isFromDuns: false,
                                },
                              });
                          }}
                        >
                          {nodes}
                          {text}
                        </div>
                      );
                    })()}
                    <Form.Item
                      className="with-radio-label"
                      label={
                        <div>
                          <div>
                            Company B Name
                            <span
                              className={
                                saveData.targetCheck
                                  ? 'not-allowed'
                                  : 'find-DUNS-num'
                              }
                              onClick={() => {
                                if (!saveData.targetCheck) {
                                  setWhichSide('target');
                                  setIsShow(!isShow);
                                }
                              }}
                            >
                              (Find a DUNS number)
                            </span>
                          </div>
                          <div className="create-project-radio-group">
                            <Radio.Group
                              name="targetRadioGroup"
                              value={saveData.targetMode || 'name'}
                              disabled={saveData.targetCheck}
                              onChange={(ele) => {
                                saveCreateProjectData({
                                  ...saveData,
                                  targetMode: ele.target.value,
                                });
                              }}
                            >
                              <Radio value="name">Company Name</Radio>
                              <Radio value="duns">DUNS Number</Radio>
                              <Radio value="website">Company Website</Radio>
                            </Radio.Group>
                          </div>
                        </div>
                      }
                      name="targetName"
                      rules={[
                        {
                          required:
                            !saveData?.targetCompanyInfo?.isFromDuns &&
                            !saveData.targetCheck,
                          whitespace: true,
                          message: 'Target Name is required!',
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              !value ||
                              getFieldValue('buyerName') !== value
                            ) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              'Target Name can not be the same as Buyer Name!',
                            );
                          },
                        }),
                      ]}
                    >
                      <Select
                        className="select company-select"
                        dropdownClassName="down-box"
                        showSearch
                        disabled={saveData.targetCheck || isShow}
                        filterOption={false}
                        notFoundContent={
                          loading ? (
                            <Spin size="small" style={{ marginLeft: '48%' }} />
                          ) : null
                        }
                        onFocus={(e) => {
                          form.setFieldsValue({ targetName: '' });
                          if (form.getFieldValue('buyerName')) {
                            form.validateFields(['buyerName']);
                          }
                          saveCreateProjectData({
                            ...saveData,
                            targetCompanyInfo: {
                              isFromDuns: false,
                            },
                          });
                        }}
                        onSearch={(e) => {
                          const val =
                            saveData.targetMode === 'website'
                              ? encodeURIComponent(e)
                              : e;
                          val &&
                            handleChange(
                              val,
                              'targetName',
                              true,
                              saveData.targetMode,
                            );
                        }}
                        onChange={(e, attrs) => {
                          saveCreateProjectData({
                            ...saveData,
                            targetName: attrs['company-name'],
                            targetCraftId: attrs['craft-id'],
                            targetDuns: attrs['target-duns'],
                          });
                          if (form.getFieldValue('buyerName')) {
                            form.validateFields(['buyerName']);
                          }
                        }}
                        onBlur={() => {
                          saveCreateProjectData({
                            ...saveData,
                            targetNotFound: false,
                          });
                        }}
                      >
                        {!loading &&
                          Array.isArray(queryCompanyResult.targetName) &&
                          queryCompanyResult.targetName.map(
                            (item) =>
                              item.displayName && (
                                <Option
                                  value={`${item.displayName} (DUNS : ${item.duns})`}
                                  craft-id={item.craftId}
                                  target-duns={item.duns}
                                  company-name={item.displayName}
                                  key={item.duns}
                                >
                                  <ul style={{ position: 'relative' }}>
                                    <li style={liStyles}>
                                      {`${item.displayName} (DUNS : ${item.duns})`}
                                    </li>
                                  </ul>
                                </Option>
                              ),
                          )}
                      </Select>
                    </Form.Item>
                    {saveData.targetNotFound &&
                      !loading &&
                      Array.isArray(queryCompanyResult.targetName) &&
                      !queryCompanyResult.targetName?.length && (
                        <div className="not-found-company-error">
                          Company not found, try locating the DUNS number in PwC
                          Salesforce account details
                        </div>
                      )}
                  </div>
                )}

                <Form.Item
                  label="Rename Company B Label"
                  name="targetLabel"
                  // style={{
                  //   order: saveData.companyInstance ? 4 : 2,
                  // }}
                >
                  <Input
                    maxLength={15}
                    placeholder={
                      saveData.instanceType !== 'Divestiture'
                        ? 'Target'
                        : 'Buyer'
                    }
                    onChange={(ele) => {
                      saveCreateProjectData({
                        ...saveData,
                        targetLabel: ele.target.value,
                      });
                    }}
                  />
                </Form.Item>
              </div>

              <Form.Item
                label="Anticipated Announcement Date"
                name="anticipatedAnnouncementDate"
              >
                <DatePicker
                  format="MM/DD/YY"
                  onChange={(date) => {
                    saveCreateProjectData({
                      ...saveData,
                      anticipatedAnnouncementDate: date ? date : null,
                    });
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Target Deal Close Date"
                name="targetDealCloseDate"
                // rules={[
                //   {
                //     required: true,
                //     message: `Target Deal Close Date is required!`,
                //   },
                // ]}
              >
                <DatePicker
                  format="MM/DD/YY"
                  onChange={(date) => {
                    saveCreateProjectData({
                      ...saveData,
                      targetDealCloseDate: date ? date : null,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={2} />
            <Col className="projectDetailRight" span={11}>
              <Form.Item
                label="What is the stage of your engagement opportunity?"
                name="stageLabel"
              >
                <Select
                  defaultValue={
                    form.getFieldValue('engagementOpportunity')
                      ? form.getFieldValue('engagementOpportunity')
                      : 'Select the stage'
                  }
                  className="select"
                  // dropdownClassName="down-box"
                  dropdownClassName="project-setting-select"
                  onChange={async (value) => {
                    await saveCreateProjectData({
                      ...saveData,
                      engagementOpportunity: value,
                    });
                  }}
                >
                  <Option value="Select the stage">Select the stage</Option>
                  <Option value="Pre-RFP">Pre-RFP</Option>
                  <Option value="Proposal / RFP">Proposal / RFP</Option>
                  <Option value="Signed Engagement / SOW">
                    Signed Engagement / SOW
                  </Option>
                  <Option value="Other">Other</Option>
                </Select>
              </Form.Item>

              <Form.Item
                className="salesforce-opportunity-id"
                label={
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}
                  >
                    <div>Salesforce Opportunity ID</div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <span
                        style={{
                          marginRight: '0.313rem',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        Not Applicable
                      </span>
                      <Checkbox
                        style={{ marginBottom: '0.625rem' }}
                        checked={
                          saveData.isSalesforceOpportunityIDApplicable === false
                        }
                        onChange={async (e) => {
                          await saveCreateProjectData({
                            ...saveData,
                            isSalesforceOpportunityIDApplicable:
                              !e.target.checked,
                            salesforceOpportunityID: null,
                          });
                        }}
                      />
                    </div>
                  </div>
                }
                name="salesforceOpportunityID"
              >
                <Input
                  value={form.getFieldValue('salesforceOpportunityID')}
                  maxLength={15}
                  disabled={
                    saveData.isSalesforceOpportunityIDApplicable === false
                  }
                  placeholder="Sample: 1054l00000zBHN1DAL"
                  onChange={(e) => {
                    saveCreateProjectData({
                      ...saveData,
                      salesforceOpportunityID: e.target.value,
                    });
                  }}
                />
              </Form.Item>

              <Form.Item
                label="Did we win the engagement?"
                name="winTheEngagement"
                initialValue={saveData.winTheEngagement}
                rules={[
                  { required: true, message: 'Option is required!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (value === 'none') {
                        return Promise.reject('Option is required!');
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Select
                  style={{
                    width: 300,
                    backgroundColor: '#2C2C2C',
                  }}
                  dropdownClassName="project-setting-select"
                  onChange={(v) => {
                    saveCreateProjectData({
                      ...saveData,
                      winTheEngagement: v,
                    });
                  }}
                >
                  <Option value="none" disabled style={{ display: 'none' }}>
                    Please select an option
                  </Option>
                  <Option value="Yes">Yes</Option>
                  <Option value="No">No</Option>
                  <Option value="not applicable">Not Applicable</Option>
                </Select>
              </Form.Item>

              <div className="check-group-title">
                Supplemental Requests (Select all that apply){' '}
                {/* <span className="title-text-14">[Select all that apply]</span> */}
              </div>
              <Form.Item name="supplementalRequests">
                <Checkbox.Group
                  options={plainOptions}
                  onChange={(arr) => {
                    saveCreateProjectData({
                      ...saveData,
                      supplementalRequests: arr,
                    });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <ProjectToast
            isShow={isShow}
            setIsShow={setIsShow}
            whichSide={whichSide}
            form={form}
            loading={loading}
          />
          <div className="form-actions-wrapper">
            <Button className="ok-btn" htmlType="submit">
              next
            </Button>
          </div>
        </Form>
      )}
      {saveData.currentNum === 2 && <ClientCompany steps={steps} />}
      {saveData.currentNum === 3 && <TargetCompany steps={steps} />}
    </div>
  );
}

const mapStateToProps = ({ projects }) => ({
  queryCompanyResult: projects.queryCompanyResult || {},
  loading: projects.queryCompanyLoading,
  saveData: projects.saveData,
});

const mapDispatchToProps = (dispatch) => ({
  queryCompanyName(word, type, isLoading, mode) {
    dispatch(action.queryCompanyName(word, type, isLoading, mode));
  },
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
  clearCompanyName(data) {
    dispatch(action.clearCompanyName(data));
  },
  changeLoading(isLoading) {
    dispatch(action.changeLoading(isLoading));
  },
  changeSettingCompanyInstance(type) {
    dispatch(action.changeSettingCompanyInstance(type));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(memo(ProjectsDetailForm));
